import type { BootstrapBundle } from "../setup/bootstrap-bundle-types.js";

export type BootRole = "agent" | "workbench";

export interface BootLogger {
  info(msg: string): void;
  warn(msg: string): void;
  error(msg: string): void;
}

export interface SessionClaims {
  taskId?: string;
  projectId?: string;
  sessionId?: string;
  workspaceId?: string;
  mode?: string;
}

export interface BootContext {
  role: BootRole;
  apiUrl: string;
  bootstrapToken: string;
  hostname: string;
  log: BootLogger;
  /** Filled by the poll step. */
  bundle?: BootstrapBundle;
  /** Filled by the unpack step. */
  claims?: SessionClaims;
  /** Filled by the unpack step — the env handed to children (runner/daemon jobs). */
  childEnv?: Record<string, string>;
}

export interface BootStep {
  name: string;
  /** true → a throw aborts boot (fatal-loud). false → degrade-and-continue (warn). */
  critical: boolean;
  run(ctx: BootContext): Promise<void>;
}

export class BootFatalError extends Error {
  constructor(
    public readonly step: string,
    message: string,
    options?: { cause?: unknown },
  ) {
    super(`[boot] FATAL step=${step}: ${message}`, options);
    this.name = "BootFatalError";
  }
}
